import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { Spin } from "antd";

import { toast } from "react-toastify";

const WarehouseAccessForm = (props) => {
  const [backImage, setBackImage] = useState(
    "https://img.freepik.com/premium-vector/anonymous-user-circle-icon-vector-illustration-flat-style-with-long-shadow_520826-1931.jpg?w=1060"
  );

  const [empData, setEmpData] = useState();
  const [empId, setEmpId] = useState();
  const [selectedWarehouses, setSelectedWarehouses] = useState([]);

  const [empCode, setEmpCode] = useState();
  const [designation, setDesignation] = useState();
  const [department, setDepartment] = useState();

  const [warehouseData, setWarehouseData] = useState();

  const [dataLoading, setDataLoading] = useState(false);

  const { sendRequest: getWarehouse } = useHttp();

  const { sendRequest: getEmployees } = useHttp();

  useEffect(() => {
    getEmployees(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          console.log(res);

          setEmpData(res.output);
        }
      }
    );
  }, [getEmployees]);

  useEffect(() => {
    getWarehouse(
      {
        url: "/api/warehouses/",
      },
      (res) => {
        if (res) {
          setWarehouseData(res);
        }
      }
    );
  }, [getWarehouse]);

  const handleEmpChange = (e) => {
    const id = e.target.value;

    setEmpId(id);

    const filteredEmp =
      empData &&
      empData.filter((item) => parseInt(item.empId) === parseInt(id));

    console.log(filteredEmp);

    setEmpCode(filteredEmp[0] && filteredEmp[0].employeeCode);
    setDepartment(filteredEmp[0] && filteredEmp[0].departmentName);
    setDesignation(filteredEmp[0] && filteredEmp[0].designationName);
    setBackImage(
      `${process.env.REACT_APP_FILE_URL}${
        filteredEmp[0] && filteredEmp[0].profileurl
      }`
    );
  };
  const handleCheckboxChange = (id) => {
    setSelectedWarehouses((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((warehouseId) => warehouseId !== id)
        : [...prevSelected, id]
    );
  };

  const { sendRequest: postWarehouseAccess } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault(false);
    //console.log(selectedWarehouses);

    const input = {
      employeeId: parseInt(empId),
      warehouseIdList: selectedWarehouses,
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
    };

    if (props.update) {
      input["warehousePermissonId"] = props.update.warehousePermissonId;
    }

    console.log(input);

    postWarehouseAccess(
      {
        url: "/api/warehousePermission/",
        method: props.update ? "PUT" : "POST",
        body: input,
      },
      (data) => {
        props.addForm(false);

        toast.success("Employee`s Warehouse Permissions Updated");
      }
    );
  };

  const { sendRequest: getUpdateData } = useHttp();

  useEffect(() => {
    const fetchData = async () => {
      setDataLoading(true); // Start loading indicator

      if (props.update) {
        console.log(props.update);

        const Id = props.update.warehousePermissonId || 0;
        getUpdateData(
          {
            url: `/api/warehousePermission/?orgId=${localStorage.getItem(
              "orgId"
            )}&warehousePermissonId=${Id}`,
          },
          (res) => {
            if (res) {
              setEmpId(props.update.employeeId);
              setEmpCode(res?.employeeCode);
              setDepartment(res?.departmentName);
              setDesignation(res?.designationName);
              setSelectedWarehouses(res.warehouseIdList);
              setBackImage(
                `${process.env.REACT_APP_FILE_URL}${res?.profileurl}`
              );
            }
          }
        );
      }

      setDataLoading(false);
    };

    fetchData();
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            &nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Warehouse Access Form </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3 text-center">
                      <div className="form-group mt-5">
                        <img
                          src={`${backImage}`}
                          className="user-image img-circle"
                          width="160"
                          height="160"
                          alt="User Image"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Employee Name</label>
                        <select
                          className="form-control"
                          style={{ width: "100%" }}
                          onChange={handleEmpChange}
                          required
                          value={empId}
                        >
                          <option value="">Select</option>
                          {empData &&
                            empData.map((x) => (
                              <option key={x.empId} value={x.empId}>
                                {x.employeeName}
                              </option>
                            ))}{" "}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Designation</label>
                        <input
                          type="text"
                          className="form-control"
                          style={{ width: "100%" }}
                          readOnly
                          value={designation}
                          onChange={(e) => {
                            setDesignation(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Employee Code</label>
                        <input
                          readOnly
                          type="text"
                          className="form-control"
                          style={{ width: "100%" }}
                          value={empCode}
                          onChange={(e) => {
                            setEmpCode(e.target.value);
                          }}
                        />
                      </div>
                      <div className="form-group">
                        <label>Department</label>
                        <input
                          type="text"
                          className="form-control"
                          style={{ width: "100%" }}
                          readOnly
                          value={department}
                          onChange={(e) => {
                            setDepartment(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3"></div>
                    <div className="col-md-8">
                      <table className="table table-bordered w-100">
                        <thead>
                          <tr>
                            <th style={{ width: 20 }}>Check</th>
                            <th>Warehouse Name</th>
                            <th>Warehouse Code</th>
                          </tr>
                        </thead>
                        <tbody>
                          {warehouseData &&
                            warehouseData.map((x, i) => (
                              <tr key={i}>
                                <td>
                                  {" "}
                                  <input
                                    className="cput"
                                    type="checkbox"
                                    checked={selectedWarehouses.includes(x.id)}
                                    onChange={() => handleCheckboxChange(x.id)}
                                  />
                                </td>
                                <td>{x.name} </td>
                                <td>{x.code} </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default WarehouseAccessForm;
